// extracted by mini-css-extract-plugin
export default {"ListItem":"CustomTodoLists_ListItem__ZOep3"};